// Tools
import { useState } from "react";
// Styles
import "./history-header.scss";
// Components
import { CompactTextInput } from "../../../../../../../../../../shared/components/inputs/compact-text-input/CompactTextInput";

interface Props {
	value: string;
	actionInput: (value: string) => void;
}

export const HistoryHeader = ({ value, actionInput }: Props) => {
	return (
		<div className='history-header'>
			<div className='history-header__wrapper window-header-wrapper'>
				<CompactTextInput
					value={value}
					actionInput={actionInput}
					placeholder='Пошук за назвою'
				/>
			</div>
		</div>
	);
};
